import { render, staticRenderFns } from "./HelpListCommon.vue?vue&type=template&id=4ca3ff5c&"
import script from "./HelpListCommon.vue?vue&type=script&lang=js&"
export * from "./HelpListCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports